// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__fcySt","alertWrapper":"styles_alertWrapper__cp-2u","alertsWrapper":"styles_alertsWrapper__WRnWh"};